import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { colors } from "../../styles/variables";

export const UserIconSvg = () => {
  const theme = useContext(ThemeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__account-icon"
      width="18"
      height="25"
      viewBox="0 0 17.787 25"
    >
      <path
        fill={theme.header?.shop?.navLinkColor || colors.white}
        id="prefix__Path_25"
        d="M79.64 123.442a4.393 4.393 0 1 1 4.392-4.393 4.4 4.4 0 0 1-4.392 4.393zm0-7.117a2.724 2.724 0 1 0 2.724 2.724 2.727 2.727 0 0 0-2.724-2.724z"
        className="prefix__cls-1"
        data-name="Path 25"
        transform="translate(-70.747 -114.657)"
      />
      <path
        fill={theme.header?.shop?.navLinkColor || colors.white}
        id="prefix__Path_26"
        d="M86.805 141.978a.834.834 0 0 1-.834-.834c0-5.965-3.241-10.818-7.225-10.818s-7.225 4.854-7.225 10.818a.834.834 0 1 1-1.668 0c0-7 3.907-12.487 8.894-12.487s8.894 5.485 8.894 12.487a.834.834 0 0 1-.836.834z"
        className="prefix__cls-1"
        data-name="Path 26"
        transform="translate(-69.852 -116.978)"
      />
    </svg>
  );
};
